import React from 'react';
import { MapPin } from 'lucide-react';

interface Step6Props {
  formData: any;
  handleChange: (field: string, value: any) => void;
}

export default function Step6Address({ formData, handleChange }: Step6Props) {
  return (
    <div className="space-y-4">
      <div>
        <label className="block text-sm font-medium text-gray-700 mb-1">
          Alamat Tempat Tinggal
        </label>
        <textarea
          value={formData.address}
          onChange={e => handleChange('address', e.target.value)}
          rows={3}
          className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:border-blue-500 transition-colors duration-200"
        />
      </div>

      <div className="grid md:grid-cols-3 gap-4">
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">Desa / Kelurahan</label>
          <input
            type="text"
            value={formData.village}
            onChange={e => handleChange('village', e.target.value)}
            className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:border-blue-500 transition-colors duration-200"
          />
        </div>

        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">Kecamatan</label>
          <input
            type="text"
            value={formData.district}
            onChange={e => handleChange('district', e.target.value)}
            className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:border-blue-500 transition-colors duration-200"
          />
        </div>

        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">Kabupaten / Kota</label>
          <input
            type="text"
            value={formData.city}
            onChange={e => handleChange('city', e.target.value)}
            className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:border-blue-500 transition-colors duration-200"
          />
        </div>
      </div>

      {/* Map Location */}
      <div className="border rounded-lg p-4 bg-gray-50">
        <div className="flex items-center gap-2 mb-3">
          <MapPin className="w-5 h-5 text-blue-600" />
          <h4 className="font-medium">Peta Lokasi</h4>
        </div>
        <div className="grid md:grid-cols-2 gap-4">
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">Latitude</label>
            <input
              type="number"
              step="any"
              value={formData.latitude || ''}
              onChange={e =>
                handleChange('latitude', e.target.value ? parseFloat(e.target.value) : null)
              }
              placeholder="-6.2088"
              className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:border-blue-500 transition-colors duration-200"
            />
          </div>
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">Longitude</label>
            <input
              type="number"
              step="any"
              value={formData.longitude || ''}
              onChange={e =>
                handleChange('longitude', e.target.value ? parseFloat(e.target.value) : null)
              }
              placeholder="106.8456"
              className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:border-blue-500 transition-colors duration-200"
            />
          </div>
        </div>
      </div>
    </div>
  );
}
